import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { CountryResponse } from "@/types/interface/region";

async function getCountry(queryParam = "") {
  return await http.get<APIResponse<CountryResponse>>(`v1/region/country/search?keyword=${queryParam}`);
}

export default {
  getCountry,
};